import { useDecision } from '@optimizely/react-sdk';
import { FEATURES } from '../optimizely/enums';

export const useIsSsoOnRemoteActivationEnabled = () => {
  const [isSsoOnRemoteActivationEnabled] = useDecision(
    FEATURES.ssoOnRemoteActivation,
    {},
  );
  return isSsoOnRemoteActivationEnabled;
};
